<div class="flex flex-col h-full">
  <p-toolbar>
    <ng-template pTemplate="start">
      <div class="flex gap-4">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input
            type="text"
            pInputText
            [(ngModel)]="driftsMeddelelserService.searchText"
            (keyup.enter)="driftsMeddelelserService.onSearch()" />
        </p-iconfield>
      </div>
    </ng-template>
  </p-toolbar>

  @let apiResponse = data.value();
  @if (apiResponse) {
    <p-table
      [value]="apiResponse.data"
      [loading]="data.isLoading()"
      [showGridlines]="true"
      stripedRows
      selectionMode="single"
      [metaKeySelection]="true"
      [(selection)]="driftsMeddelelserService.selectedDriftsMeddelelse"
      (onRowSelect)="onRowSelect($event)"
      dataKey="id"
      [scrollable]="true"
      scrollHeight="flex"
      class="flex-1 overflow-hidden p-datatable-sm mt-4">
      >
      <ng-template pTemplate="header">
        <tr>
          <th>Id</th>
          <th>Start</th>
          <th>Slut</th>
          <th>Status</th>
          <th>Emne</th>
          <th>Indhold</th>
          <th>Produkt</th>
          <th>ITC</th>
          <th>Regnr</th>
          <th>System</th>
        </tr>
      </ng-template>
      <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
        <tr [pSelectableRow]="item" class="cursor-pointer align-top">
          <td>
            {{ item.id }}
          </td>
          <td style="width: 130px">
            {{ item.start | date: 'dd-MM-yyyy HH:mm' }}
          </td>
          <td style="width: 130px">
            {{ item.slut | date: 'dd-MM-yyyy HH:mm' }}
          </td>
          <td style="width: 80px">
            {{ item.redigeringsStatus }}
          </td>
          <td style="width: 200px">
            {{ item.emne }}
          </td>
          <td>
            <div [innerHTML]="item.indhold" class="besked-tekst"></div>
          </td>
          <td style="width: 150px">
            <div class="besked-tekst">
              {{ (item.produkter || '').replaceAll(',', ' ') }}
            </div>
          </td>
          <td>{{ item.itc }}</td>
          <td>{{ item.regNr }}</td>
          <td>{{ (item.driftsystem || '').replaceAll(',', ' ') }}</td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
